export enum RoomType {
  Open = 'Open',
  Private = 'Private',
}

export enum GameLength {
  Short = 'Short',
  Medium = 'Medium',
  Long = 'Long',
}

export const HEARTS_BY_GAME_LENGTH: Record<GameLength, number> = {
  [GameLength.Short]: 3,
  [GameLength.Medium]: 6,
  [GameLength.Long]: 9,
};

export const roomTypes = Object.values(RoomType);
export const gameLengths = Object.values(GameLength);
